<template>
  <div
    class="rounded shadow-hard bg-white overflow-hidden flex flex-col"
  >
    <span
      class="bg-primary h-full w-full
        min-h-[10px] min-w-[10px] laptop:min-h-[15px] laptop:min-w-[15px]"
    />

    <div
      class="relative"
    >
      <NuxtPicture
        :src="props.image.src"
        :alt="props.image.alt || ''"
        :title="props.image.title"
        loading="lazy"
        class="absolute inset-0"
      />

      <div
        class="relative z-10 mx-8 my-12 flex flex-col gap-4"
      >
        <h2
          class="text-white text-shadow-light text-center"
        >
          {{ t('jc.component.joinCard.heading') }}
        </h2>

        <p
          class="text-white text-shadow-light text-center laptop:mx-16"
        >
          {{ t('jc.component.joinCard.paragraph', { serverName: server }) }}
        </p>

        <button
          :title="t('jc.component.joinCard.link.title')"
          class="bg-primary hover:bg-primary-highlighted active:bg-primary-selected text-white
            text-center rounded py-2 px-4 mt-10 mx-auto font-semibold"
          @click="() => copyMinecraftIp()"
        >
          <font-awesome-icon
            icon="play"
            class="mr-2"
          />
          <span>{{ t('jc.component.joinCard.button.label') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import type { Image } from '~/utils/types'

const { t } = useI18n()
const copyMinecraftIp = useCopyMinecraftIp()

const props = defineProps<{
  server: string
  image: Image
}>()
</script>

<style scoped lang="postcss">
:deep(img) {
  @apply w-full h-full object-cover
}
</style>
